import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Label } from 'reactstrap'



export default function Footer() {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [isDisclaimer, setIsDisclaimer] = useState(false);
  useEffect(() => {
    const updateScrollPercentage = () => {
      const scrollPx = document.documentElement.scrollTop;
      const winHeightPx =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = (scrollPx / winHeightPx) * 100;

      setScrollPercentage(scrolled);
    };

    window.addEventListener('scroll', updateScrollPercentage);

    return () => {
      window.removeEventListener('scroll', updateScrollPercentage);
    };
  }, []);

  useEffect(() => {
    let time = null;
    const getData = async () => {
      const item = await localStorage.getItem('policy');
      console.log('policy from storage', item);
      if (!item)
        time = setTimeout(() => {
          setIsDisclaimer(true)
        }, 3000);
    }
    getData();
    return () => clearTimeout(time);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsDisclaimer(true);
      } else {
        setIsDisclaimer(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const handleOkayDisclaimer = () => {
    setIsDisclaimer(false);
    localStorage.setItem('policy', 'agreed');
  }

  return (
    <footer className="footer-section" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="row">

            {/* Company Info Section */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="footer-logo mb-3">
                {/* <img src={require('../assets/images/logo.png')} alt='Triburg Logo' className="img-fluid" /> */}
                <h3>Triburg Freight Services LLC</h3>
              </div>
              <p className="footer-description">
                Your trusted partner for freight and logistics services across the Middle East.
                Delivering logistics innovation with unmatched reliability and scale.
              </p>

              <div className="social-icons-group" style={{ textAlign: 'left' }}>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>

            {/* Services Section */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="footer-heading">Services</h5>
              <ul className="footer-links-list">
                <li><Link to="/warehousing">Warehousing</Link></li>
                <li><Link to="/vas-activity">VAS Services</Link></li>
                <li><Link to="/transportation">Freight & Transportation</Link></li>
              </ul>
            </div>

            {/* Locations Section */}
            <div className="col-lg-2 col-md-6 mb-4">
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="footer-links-list">
                <li><Link to="/">About TFS</Link></li>
                <li><Link to="/services">Services Offered</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            {/* Quick Links Section */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="footer-heading">Contact Info</h5>
              <div className="footer-contact-list">
                <div className="footer-contact-item">
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:sales@Triburg.com">sales@Triburg.com</a>
                </div>
                <div className="footer-contact-item">
                  <i className="fas fa-phone-alt"></i>
                  <a href="tel:+971555577410">+971 55 5577410</a>
                </div>
                <div className="footer-contact-item">
                  <i className="fab fa-whatsapp"></i>
                  <a href="https://wa.me/971555577410" target="_blank" rel="noopener noreferrer">Chat on WhatsApp</a>
                </div>
                <div className="footer-contact-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>PLOT MOD119, ROAD NO 400, LANE N408
                    JEBEL ALI FREEZONE, DUBAI, UAE</span>
                </div>
              </div>

              {/* Social Icons */}

            </div>

          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
              <p className="footer-copyright">
                © 2026 TRIBURG FREIGHT SERVICES. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <p className="footer-credit">
                <a href="/privacy-policy">Privacy Policy</a>
                <span className="footer-separator">|</span>
                <a href="/terms">Terms of Service</a>
                <span className="footer-separator">|</span>
                <a href="https://www.cloudmind.ae/" target="_blank" rel="noopener noreferrer">Design by Cloud Mind</a>
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/971555577410"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat on WhatsApp"
        style={{ textDecoration: 'none' }}
      >
        <i className="fab fa-whatsapp"></i>
        <span>Need Help?</span>
      </a>
    </footer>
  )
}


